import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { fonts } from "../common/mixins.js";

const Small = styled.div`
  ${fonts.normalTextSmall()};
  display: inline;
  word-break: break-word;
  hyphens: manual;
`;
const Light = styled.div`
  font-family: "pf_highway_sans_pro_lightRg";
  flex-shrink: 0;
  display: inline;
  margin-right: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #a8abaf;
`;

const DetailsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const DetailRow = styled.div``;
export default function TicketDetails({ details }) {
  const { nameSurname, zone, section, rowSeat, price } = details;
  return (
    <DetailsContainer id="ticketDetails">
      {nameSurname?.trim().length > 0 && (
        <DetailRow>
          <Light>{orderdetails_resources.NameSurname}</Light>
          <Small id="name">{nameSurname}</Small>
        </DetailRow>
      )}
      <DetailRow>
        <Light>{orderdetails_resources.ZoneDiscount}</Light>
        <Small id="zone">{zone}</Small>
      </DetailRow>
      <DetailRow>
        <Light>{orderdetails_resources.Section}</Light>
        <Small id="section">{section}</Small>
      </DetailRow>
      <DetailRow>
        <Light>{orderdetails_resources.RowSeat}</Light>
        {rowSeat === "Unnumbered" ? (
          <Small id="rowSeatUnnumbered">
            {orderdetails_resources.Unnumbered}
          </Small>
        ) : (
          <Small id="rowSeat">{rowSeat}</Small>
        )}
      </DetailRow>
      <DetailRow>
        <Light>{orderdetails_resources.Price}</Light>
        <Small id="price">{price}</Small>
      </DetailRow>
    </DetailsContainer>
  );
}
